export interface ICount {
  count: number;
}
